import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetScrapFinanceTradesService } from "@/features/accounts/scrap-finance/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetScrapFinanceTradesResponseModel } from "@/features/accounts/scrap-finance/services/get-trades-model";


export const useGetScrapFinanceTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getScrapFinanceTradesService = new GetScrapFinanceTradesService();

  // 銀行明細一覧取得
  const getScrapFinanceTrades = async (
    accountGroupId: string,
    financeAccountId: string,
    financeId: string,
    startDate?: string,
    endDate?: string,
  ) :Promise<GetScrapFinanceTradesResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getScrapFinanceTradesService.getScrapFinanceTrades({
        account_group_id:  accountGroupId,
        scrap_finance_account_id: financeAccountId,
        scrap_finance_id: financeId,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getScrapFinanceTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getScrapFinanceTrades: errorHandledAsync(getScrapFinanceTrades, setError),
  };
};
